export const REQUEST_TIMEOUT = 5_000;
export const GROUP_RESULT_LIMIT = 5;
export const USER_RESULT_LIMIT = 10;
export const MAX_RESULT_COUNT = 15;
